var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.$store.getters['resource/currentResource'].key},[_c('div',{staticClass:"white-container"},[_c('TemplateView',{attrs:{"fields":_vm.fields}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }